import React, { useEffect, useState } from 'react';
import { Grid, Tabs, Tab } from '@mui/material';
import CbProduction from './data-monitoring/CbProduction';
import CbFieldNotes from './data-monitoring/field-notes/CbFieldNotes';

const CONSERVATION_BURNS_TABS = [
    'Production',
    'Field Notes'
]

export default function CbDataMonitoring({ burnType }) {
    const [selectedTab, setSelectedTab] = useState('Production');

    useEffect(() => {
        setSelectedTab('Production')
    }, [burnType])

    return (
        <Grid container gap={3}>
            <Grid item sx={{ display: 'flex', width: '100%' }}>
                <Tabs
                    value={selectedTab}
                    onChange={(event, newValue) => setSelectedTab(newValue)}
                >
                    {CONSERVATION_BURNS_TABS.map((tab) => (
                        <Tab
                            key={tab}
                            label={tab}
                            value={tab}
                        // disabled={tab !== 'Production'}
                        />
                    ))}
                </Tabs>
            </Grid>
            {
                selectedTab === 'Production' &&
                <CbProduction />
            }
            {
                selectedTab === 'Field Notes' &&
                <CbFieldNotes />
            }
        </Grid>
    );
}
